exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".android-banner{display:flex;align-items:center;justify-content:space-around;padding:3px 5px;border-bottom:1px solid #8d9aa5;background-color:#dde3e6}.android-banner .close-icon{font-size:25px}.android-banner__text{display:flex;flex-direction:column;font-size:12px}.android-banner__title{font-size:16px;font-weight:700}", ""]);

